import Vue from 'vue';
import Router from 'vue-router';

const original = Router.prototype.push;
Router.prototype.push = function push (location) {
    return original.call(this, location).catch(err => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace (location) {
    return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: r => require.ensure([], () => r(require('@/pages/home/index.vue')), 'HomePage')
    },
    {
        path: '/loading',
        name: 'Loading',
        component: r => require.ensure([], () => r(require('@/pages/loading/index.vue')), 'LoadingPage')
    },
    {
        path: '/chat',
        name: 'Chat',
        component: r => require.ensure([], () => r(require('@/pages/chat/index.vue')), 'ChatPage')
    },
    {
        path: '/stay',
        name: 'Stay',
        component: r => require.ensure([], () => r(require('@/pages/stay/index.vue')), 'StayPage')
    }
];

const router = new Router({
    mode: 'history', // history || hash
    base: '/',
    routes: routes,
    scrollBehavior () {
        return {
            x: 0,
            y: 0
        };
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js